export const environment = {
  production: true,
  useEmulators: false,
  database: 'dev',
  firebaseEnv: {
    apiKey: 'AIzaSyC9APnYPTOBlctD_TTJBaFffWH-1DHnvRQ',
    authDomain: 'rewirenpc-dev.firebaseapp.com',
    databaseURL: 'https://rewirenpc-dev.firebaseio.com',
    projectId: 'rewirenpc-dev',
    storageBucket: 'rewirenpc-dev.appspot.com',
    messagingSenderId: '738711015646',
    appId: '1:738711015646:web:23c9b7611c3341a5d4724f'
  },
  appCheck: {
    siteKey: '6Lek27csAAAAAG8Q4fFLMUwMFFhIrCiJxa8zNiQy'
  },
  previewUrl: 'https://rewirenpc-dev.firebaseapp.com/preview/app/',
  functionsURL: `https://us-central1-rewirenpc-dev.cloudfunctions.net/`
};
